// cross-curriculum
import { ReactComponent as SustainabilityInline } from '../icons/cross-curriculum-priorities/sustainability.inline.svg';
import { ReactComponent as AborginalTorresInline } from '../icons/cross-curriculum-priorities/aboriginal-torres.inline.svg';
import { ReactComponent as AsiaAustraliaInline } from '../icons/cross-curriculum-priorities/asia-australia.inline.svg';

// general capabilities
import { ReactComponent as InterculturalInline } from '../icons/general-capabilities/intercultural.inline.svg';
import { ReactComponent as CriticalCreativeInline } from '../icons/general-capabilities/critical-creative.inline.svg';
import { ReactComponent as LiteracyInline } from '../icons/general-capabilities/literacy.inline.svg';
import { ReactComponent as ICTInline } from '../icons/general-capabilities/ict.inline.svg';
import { ReactComponent as PersonalAndSocialResponsibililtyInline } from '../icons/general-capabilities/personal-and-social-responsibility.inline.svg';
import { ReactComponent as EthicalUnderstandingInline } from '../icons/general-capabilities/ethical-understanding.inline.svg';
import { ReactComponent as IconNumeracy } from '../icons/general-capabilities/numeracy.svg';

// stimulus/thumbnail types
import { ReactComponent as IconAudio } from '../icons/icon_audio.svg';
import { ReactComponent as IconDocument } from '../icons/icon_document.svg';
import { ReactComponent as EBook } from '../icons/icon_e-book.svg';
import { ReactComponent as IconImage } from '../icons/icon_image.svg';
import { ReactComponent as IconLink } from '../icons/icon_link.svg';
import { ReactComponent as IconVideo } from '../icons/icon_video.svg';
import { ReactComponent as IconWebTool } from '../icons/icon_web-tool.svg';
import { ReactComponent as IconWorksheet } from '../icons/icon_worksheet.svg';
import { ReactComponent as IconInteractive } from '../icons/icon_game.svg';
import { ReactComponent as IconEbookInteractive } from '../icons/icon_ebook_interactive.svg';

// miscellaneous
import { ReactComponent as IconSearch } from 'approot/shared/icons/icon_search.svg';

type AnyObject = {
  [key: string]: any;
};

export const inlineSvgMapping = {
  // cross-curriculum
  sustainability: SustainabilityInline,
  'aboriginal-torres': AborginalTorresInline,
  'asia-australia': AsiaAustraliaInline,

  // general capabilities
  'critical-creative': CriticalCreativeInline,
  'ethical-understanding': EthicalUnderstandingInline,
  ict: ICTInline,
  intercultural: InterculturalInline,
  literacy: LiteracyInline,
  numeracy: IconNumeracy,
  'personal-and-social-responsibility': PersonalAndSocialResponsibililtyInline,

  // stimulus/... content types
  audio: IconAudio,
  document: IconDocument,
  'e-book': EBook,
  'e-book-interactive': IconEbookInteractive,
  book: EBook,
  'guided-research': IconSearch,
  image: IconImage,
  link: IconLink,
  video: IconVideo,
  'web-tool': IconWebTool,
  worksheet: IconWorksheet,
  interactive: IconInteractive,
};

export type InlineSvgIds = keyof typeof inlineSvgMapping;

export type Props = {
  id: InlineSvgIds;
  // you might need to rebuild the inline SVGs by running `yarn run build-svg`
  // to embed them in the index.html
  width?: string | number;
  height?: string | number;
  className?: string;
  label?: string;
  $rotate?: number;
};

const InlineSvg = (props: Props) => {
  const svgProps: AnyObject = {};
  //Setting a fallback small width/height (where not passed througoh as a prop),
  //so that we don't see massive SVGs before the CSS Loads.
  //Note, if we ever want to use an SVG that should display at its natural size,
  //we might want to consider a new prop for that (e.g. 'naturalSize')
  props.width ? (svgProps.width = props.width) : (svgProps.width = 16);
  props.height ? (svgProps.height = props.height) : (svgProps.height = 16);
  if (props.className) svgProps.className = `${props.id} ${props.className}`;
  if (props.label) svgProps['aria-label'] = props.label;
  const Svg = inlineSvgMapping[props.id];
  if (!Svg) {
    console.error(`Received invalid id prop "${props.id}" to inline-svg.js`);
    return null;
  }
  return (
    <Svg
      {...svgProps}
      focusable="false"
      style={
        props.$rotate
          ? {
              transform: `rotate(${props.$rotate}deg)`,
            }
          : {}
      }
    />
  );
};

export default InlineSvg;
